import { useQuery, keepPreviousData } from '@tanstack/react-query';
import fetchAPI from '../fetchAPI';

interface Props {
  type?: string;
  status?: string;
  companyName?: string;
  pageNumber?: number;
  pageSize?: number;
  sortBy?: string | string[];
  priceModel?: string;
}

export const useBillingAccountsDetailedList = ({
  type,
  status,
  companyName,
  pageNumber,
  pageSize,
  sortBy,
  priceModel,
}: Props) => {

  const queryParams = new URLSearchParams();
  if (pageNumber) {
    queryParams.append('pageNumber', pageNumber.toString());
  }
  if (pageSize) {
    queryParams.append('pageSize', pageSize.toString());
  }
  if (companyName) {
    queryParams.append('companyName', companyName);
  }
  if (type) {
    queryParams.append('type', type);
  }
  if (status) {
    queryParams.append('status', status);
  }
  if (sortBy) {
    if (Array.isArray(sortBy)) {
      sortBy.forEach((sort) => queryParams.append('sortBy', sort));
    } else {
      queryParams.append('sortBy', sortBy);
    }
  }
  if (priceModel) {
    queryParams.append('priceModel', priceModel);
  }

  const queryString = queryParams.toString();

  return useQuery({
    queryKey: ['billing-accounts/detailed-list', type, pageNumber, pageSize, companyName, status, sortBy, priceModel],
    queryFn: async () => {
      const response = await fetchAPI<Pagination<BillingAccount>>({
        method: `GET`,
        route: `billing-accounts/detailed-list`,
        queryString
      });
      return response;
    },
    enabled: true,
    // Keep the previous page visible during pagination/filter changes so the
    // table doesn't flash to empty + spinner between fetches.
    placeholderData: keepPreviousData
  });
};

export default useBillingAccountsDetailedList;
